// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3OeNY","col":"Table_col__2nRvM","fulfillmentStatus":"Table_fulfillmentStatus__Cdqs9","emailCol":"Table_emailCol__3NqV3"};